export default function getImagesFromAPI({ src }: { src: string }) {
  if (src.includes('_next/static')) {
    return src;
  }

  return `/api/files/${src}`;
}
